export default [
  {
    title: 'Live Streams',
    icon: 'MonitorIcon',
    route: 'home',
  },
  {
    title: 'Categories',
    icon: 'GridIcon',
    route: 'categories',
  },
  {
    title: 'Clip Review',
    icon: 'PlayIcon',
    route: 'clips',
  },
  {
    header: 'Following (Live)',
    class: 'sidebar-follow-text',
  },
  // {
  //   title: 'BrimePro™',
  //   icon: 'BoldIcon',
  //   route: 'BrimePro',
  // },
]
